import React, { PropTypes } from 'react';
// import { EditorState, createDecorator } from 'draft-js';
import { Input } from 'antd';
import cn from 'classnames';
import styles from './styles.scss';

export default class CustomEditor extends React.Component {
  componentDidMount() {
    this.props.onChange(this.props.initValue);
  }
  onChangeWithLimit(element, limit, onChange) {
    if (limit) {
      if (element.target.value.length > limit) {
        return;
      }
      onChange(element);
    }
    onChange(element);
  }

  renderCounter(value, limit) {
    return (
      <div className={styles.counter}>
        {value.length} / {limit}
      </div>
    );
  }

  render() {
    const { error, labelName, showCounter, showExample, initValue, ...props } = this.props;
    return (
      <div
        className={cn('form-group', {
          'has-error': error,
        })}
      >
        {labelName && <label className={cn('control-label', styles.inputTitle)} dangerouslySetInnerHTML={{ __html: labelName }} />}
        {showExample && (
          <div className={styles.seeExample}>
            <span>ดูตัวอย่าง</span>
          </div>
        )}
        <Input className="form-control" {...props} onChange={(value) => this.onChangeWithLimit(value, props.limit, props.onChange)} />
        {error && <span className="help-block">{error}</span>}
        {showCounter && props.limit && <div>{this.renderCounter(props.value, props.limit)}</div>}
      </div>
    );
  }
}
